module.exports = __webpack_public_path__ + "static/media/summernote.03f45d88.woff";